export default __webpack_public_path__ + "static/sailsquare-7f36136acefeeb959778c3bbda16b140.svg";